import React from 'react';
import PropTypes from 'prop-types';
import s from './ButtonDelete.module.scss';

const ButtonDelete = ({ children, onClick }) => (
    <button type="button" className={s['ButtonDelete']} onClick={onClick}>
        {children}
    </button>
);

ButtonDelete.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
};


export default ButtonDelete;
